import { ApiResult } from "~/models/ApiResult";
import { type AxiosResponse } from "axios";
import { BaseService } from "./BaseService";
import type { GetAdvertisementAllRequest, GetAdvertisementAllResponse, GetAdvertisementByIdRequest, GetAdvertisementByIdResponse } from "~/models/AdvertisementModels";
import type { GetCalendarRequest, GetCalendarResponse } from "~/models/PreSaleAdvantageModels";

export class PreSaleAdvantageService extends BaseService {
  constructor() {
    super("PreSaleAdvantage");
  }
  List(query: GetAdvertisementAllRequest): Promise<AxiosResponse<ApiResult<Array<GetAdvertisementAllResponse>>>> {
    let queryString = '?';
    let prepend = '';

    // Sadece dolu alanları eklemek için kontrol
    if (query.pageNumber) {
      queryString += `${prepend}PageNumber=${query.pageNumber}`;
      prepend = '&';
    }
    if (query.pageSize) {
      queryString += `${prepend}PageSize=${query.pageSize}`;
      prepend = '&';
    }
    if (query.search) {
      queryString += `${prepend}Search=${encodeURIComponent(query.search)}`;
      prepend = '&';
    }
    if (query.provinceId) {
      queryString += `${prepend}ProvinceId=${query.provinceId}`;
      prepend = '&';
    }
    if (query.districtId) {
      queryString += `${prepend}DistrictId=${query.districtId}`;
      prepend = '&';
    }
    if (query.minRentalIncome) {
      queryString += `${prepend}MinRentalIncome=${query.minRentalIncome}`;
      prepend = '&';
    }
    if (query.minPrice) {
      queryString += `${prepend}MinPrice=${query.minPrice}`;
      prepend = '&';
    }
    if (query.maxPrice) {
      queryString += `${prepend}MaxPrice=${query.maxPrice}`;
      prepend = '&';
    }
    if (query.orderType) {
      queryString += `${prepend}OrderType=${query.orderType}`;
      prepend = '&';
    }
    if (query.productDeveloperId) {
      queryString += `${prepend}ProductDeveloperId=${query.productDeveloperId}`;
      prepend = '&';
    }
    if (query.rateOfPieceFilter) {
      const rateOfPieceFilter = Array.isArray(query.rateOfPieceFilter)
        ? query.rateOfPieceFilter
        : [query.rateOfPieceFilter];

      rateOfPieceFilter.forEach((value: number) => {
        queryString += `${prepend}RateOfPieceFilter=${value}`;
        prepend = '&';
      });
    }
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/List${queryString}`);
  }
  Detail(query: GetAdvertisementByIdRequest): Promise<AxiosResponse<ApiResult<GetAdvertisementByIdResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/Detail?`, query);
  }
  GetCalendar(): Promise<AxiosResponse<ApiResult<GetCalendarResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/Calendar`);
  }
  SubmitPreSaleForm(body: any): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/Form`, body);
  }
}